<template>
    <div class="stat">
        <div class="icon">
            <img :src="iconSrc"/>
        </div>
        <p :if="stat" class="number">{{stat}}</p>
        <p class="text">{{title}}</p>
    </div>
</template>

<script>
    export default {
        name: "stats-icon",
        props: {
            'icon-src': {
                type: String,
                required: true
            },
            'stat': {
                type: String
            },
            'title': {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped lang="scss">
    .stat {
        display: grid;
        grid-auto-flow: row;
        grid-gap: 4px;
        text-align: center;
        align-content: start;
        justify-content: center;

        .icon {
            width: 64px;
            height: 64px;
            padding: 8px;
            background: $entelect-light-green;
            border-radius: 50%;
            display: grid;
            align-self: start;
            justify-self: center;
            align-content: center;
            justify-content: center;

            img {
                max-height: 40px;
                max-width: 40px;
            }
        }

        .number {
            font-size: 30px;
            font-weight: bold;
        }

        .text {
            font-size: 16px;
            color: $entelect-orange;
            font-weight: 900;
        }
    }
</style>